import PropTypes from 'prop-types';
import { Modal, Box, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MaintenanceBannerDetailsForm from './MaintenanceBannerDetailsForm';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '96%',
  maxWidth: 900,
  maxHeight: '92vh',
  overflow: 'auto',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 1,
  p: 3,
};

export default function MaintenanceBannerAdminModal({ open, onClose }) {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="maintenance-banner-modal-title">
      <Box sx={style}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
          <Typography id="maintenance-banner-modal-title" variant="h6" component="h2">
            Maintenance banner
          </Typography>
          <IconButton onClick={onClose} aria-label="close" size="small">
            <CloseIcon />
          </IconButton>
        </Box>
        <MaintenanceBannerDetailsForm onSaveSuccess={onClose} onCancel={onClose} />
      </Box>
    </Modal>
  );
}

MaintenanceBannerAdminModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
